import { gql } from '@apollo/client'

const CREATIVE_REPONSES_QUERY = gql`
  query CreativeResponsesQuery( $where: responses_bool_exp! ) {
    creativeResponses: responses(
      where: $where
      order_by: { created_at: desc }
    ) {
      id
      name
      sharing
      user_id
      image_object
      audio_object
      file_data
      age
      country
      created_at
      approved_at
      language
      user {
        id
        email
      }
      activity {
        ...on activities_default_Entry {
          id: canonicalId,
          slug
          title
          activityType {
            ...on activityTypes_Category {
              id
              title
              slug
            }
          }
        }
      }
    }
  }
`
  
export default CREATIVE_REPONSES_QUERY
